import { atom, type Atom, type Getter, type WritableAtom } from 'jotai';
import { selectAtom } from 'jotai/utils';

import type { BigNumber } from '@flipster/utils/num';

function areBigNumbersEqual(a: BigNumber | undefined, b: BigNumber | undefined): boolean {
  if (a == undefined || b == undefined) return a === b;
  return a.isEqualTo(b);
}

export function atomWithBigNumber(
  initialValue: BigNumber,
): WritableAtom<BigNumber, [BigNumber | ((prev: BigNumber) => BigNumber)], void>;
export function atomWithBigNumber(
  initialValue: BigNumber | undefined,
): WritableAtom<
  BigNumber | undefined,
  [BigNumber | undefined | ((prev: BigNumber | undefined) => BigNumber | undefined)],
  void
>;
export function atomWithBigNumber(read: (get: Getter) => BigNumber): Atom<BigNumber>;
export function atomWithBigNumber(read: (get: Getter) => BigNumber | undefined): Atom<BigNumber | undefined>;

export function atomWithBigNumber(params: BigNumber | undefined | ((get: Getter) => BigNumber | undefined)) {
  if (typeof params === 'function') {
    const getter = params;
    return selectAtom(atom(getter), (x) => x, areBigNumbersEqual);
  }

  const initValue = params;
  const baseAtom = atom<BigNumber | undefined>(initValue);
  return atom(
    (get) => get(baseAtom),
    (get, set, update: BigNumber | undefined | ((prev: BigNumber | undefined) => BigNumber | undefined)) => {
      const next = typeof update === 'function' ? update(get(baseAtom)) : update;
      if (!areBigNumbersEqual(get(baseAtom), next)) {
        set(baseAtom, next);
      }
    },
  );
}
